/**
 * SISTEMA DE CÓDIGOS DE ERRO
 * Mensagens amigáveis para o usuário
 */

export interface ErrorResponse {
  code: string;
  message: string;
  technicalDetails?: string;
}

export function getErrorMessage(error: any): ErrorResponse {
  const errorString = error?.message || String(error);
  
  // Erro de modelo não encontrado (404)
  if (errorString.includes('404') || errorString.includes('not_found')) {
    return {
      code: '06',
      message: 'Modelo de IA não encontrado ou indisponível. Por favor, selecione outro modelo.',
      technicalDetails: errorString
    };
  }
  
  // Erro de autenticação (401)
  if (errorString.includes('401') || errorString.includes('unauthorized') || errorString.includes('invalid_api_key')) {
    return {
      code: '01',
      message: 'Erro de autenticação com a API. Verifique suas credenciais.',
      technicalDetails: errorString
    };
  }
  
  // Erro de cota excedida (OpenAI: insufficient_quota / 429)
  if (errorString.includes('insufficient_quota') || errorString.includes('exceeded your current quota')) {
    return {
      code: '02',
      message: 'Cota da API OpenAI excedida. Verifique seu plano e cobrança em platform.openai.com.',
      technicalDetails: errorString
    };
  }
  // Erro de limite/rate (429)
  if (errorString.includes('429') || errorString.includes('rate_limit') || errorString.includes('quota')) {
    return {
      code: '02',
      message: 'Limite de requisições atingido. Aguarde alguns instantes e tente novamente.',
      technicalDetails: errorString
    };
  }
  
  // Erro de servidor (500, 502, 503)
  if (errorString.includes('500') || errorString.includes('502') || errorString.includes('503')) {
    const isSaipos = /Saipos|cardápio|catalog|order-api/i.test(errorString);
    const message = isSaipos
      ? 'Serviço Saipos temporariamente indisponível (pode ser o cardápio ou a API). Tente novamente em alguns instantes.'
      : 'Servidor temporariamente indisponível. Tente novamente em alguns instantes.';
    return {
      code: '03',
      message,
      technicalDetails: errorString
    };
  }
  
  // Erro de connection pool do Saipos (servidor sobrecarregado)
  if (errorString.includes('connection pool') || errorString.includes('timed out acquiring')) {
    return {
      code: '04',
      message: 'O servidor Saipos está temporariamente sobrecarregado. Aguarde alguns segundos e tente novamente.',
      technicalDetails: errorString
    };
  }

  // Erro de timeout genérico
  if (errorString.includes('timeout') || errorString.includes('timed out')) {
    return {
      code: '04',
      message: 'A requisição demorou muito tempo. Tente novamente.',
      technicalDetails: errorString
    };
  }
  
  // Erro de conteúdo (content policy)
  if (errorString.includes('content_policy') || errorString.includes('safety')) {
    return {
      code: '05',
      message: 'Conteúdo violou as políticas de uso. Reformule sua mensagem.',
      technicalDetails: errorString
    };
  }
  
  // Erro de parâmetro inválido
  if (errorString.includes('invalid_request') || errorString.includes('bad_request')) {
    return {
      code: '07',
      message: 'Requisição inválida. Tente reformular sua pergunta.',
      technicalDetails: errorString
    };
  }
  
  // Erro de conexão/rede
  if (errorString.includes('network') || errorString.includes('fetch failed') || errorString.includes('ECONNREFUSED')) {
    return {
      code: '08',
      message: 'Erro de conexão. Verifique sua internet e tente novamente.',
      technicalDetails: errorString
    };
  }
  
  // Erro genérico
  return {
    code: '99',
    message: 'Ocorreu um erro inesperado. Tente novamente.',
    technicalDetails: errorString
  };
}

/**
 * Formatar mensagem de erro para o usuário
 */
export function formatErrorMessage(error: any, includeCode: boolean = true): string {
  const errorResponse = getErrorMessage(error);
  
  if (includeCode) {
    return `[Erro ${errorResponse.code}] ${errorResponse.message}`;
  }
  
  return errorResponse.message;
}

